/**
 * ATNA Logging API Documentation
 * Rest API used to query log entries
 *
 * OpenAPI spec version: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class User { 
    constructor(json: JSON | any) {
        Object.assign(this as User, json)
    }

    username?: string;
    password?: string;
}

